module.exports = __webpack_public_path__ + "media/images/riders/small/MONIKA_HRASTNIK-ba85b8e57ae1010be401f51084ba3507.png";